import { createContext } from 'react';

import { ITableContextValue } from './interfaces';

const TableContext = createContext<ITableContextValue>({
  template: 'normal',
});

export default TableContext;
